<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="place_box">
          <div class="place_title">收货地址</div>
          <ul class="address">
            <li
              :class="chooseAddIndex == index ? 'on' : ''"
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectAddress(index)"
            >
              <div class="add_item">
                <div>{{ item.consignee }}</div>
                <div>{{ item.telePhone }}</div>
              </div>
              <div class="add_text">
                {{ item.detailAddress }}
              </div>
            </li>
            <li class="add" @click="setAddress()">
              <div class="address_add">新增收货地址</div>
            </li>
          </ul>
        </div>
        <div class="place_box">
          <div class="place_title">支付方式</div>
          <div class="list paytype">
            <div
              class="item"
              :class="payType == 1 ? 'paytypeon' : ''"
              @click="selectPayType(1)"
            >
              微信支付
            </div>
            <div
              class="item"
              :class="payType == 4 ? 'paytypeon' : ''"
              @click="selectPayType(4)"
            >
              支付宝支付
            </div>
          </div>
        </div>
        <div class="place_box info">
          <div class="thead">
            <div class="th1">订单信息</div>
            <div class="th2">单价</div>
            <div class="th3">数量</div>
            <div class="th4">金额</div>
          </div>
          <div
            class="tbody"
            v-for="(item, index) in items.products"
            :key="index"
          >
            <div class="td1">
              <div class="td_img">
                <img :src="item.productImg" alt="" srcset="" class="td_img" />
              </div>
              <div class="td_con">
                <div class="td_title">
                  {{ item.productName }}
                </div>
                <div class="td_text_con">
                  {{ item.skuName }}
                </div>
              </div>
            </div>
            <div class="td2">
              <div>{{ item.productPrice }}</div>
            </div>
            <div class="td3">
              {{ item.productNum }}
            </div>
            <div class="td4">
              <div>{{ item.productTotalPrice }}</div>
            </div>
          </div>
        </div>
        <div class="place_box roll" v-if="couponList.length > 0">
          <div class="place_title">使用优惠券</div>
          <ul class="place_roll">
            <li
              class="roll_item"
              v-for="(item, index) in couponList"
              :key="index"
              @click="selectConp(item, index)"
              :class="item.status === 0 ? 'on' : ''"
            >
              <div class="roll_con">
                <div class="roll_sum">
                  <em>￥{{ item.reducePrice }}</em>
                  <i
                    ><span>{{ item.title }}</span></i
                  >
                </div>
                <div class="roll_title">
                  {{ item.typeName }}
                </div>
                <div class="roll_time">
                  {{ item.startTime }} - {{ item.expirationTime }}
                </div>
              </div>
              <div
                class="select_item"
                :class="item.id === couponId ? 'select_item_on' : ''"
              ></div>
            </li>
          </ul>
        </div>
        <div class="balac" @click="leaveHandle()">
          <div
            class="select_item"
            :class="balanceDeduction ? 'select_item_on' : ''"
          ></div>
          <div>余额抵扣</div>
        </div>
        <div class="place_box total">
          <div class="plac_leave" v-if="items.deduction > 0">
            <div class="leave_item">
              <i>实付</i><em>￥{{ items.actualPayment }}</em>
            </div>
            <div class="leave_item">
              <i>抵扣</i><em>￥{{ items.deduction }}</em>
            </div>
          </div>
          <div class="place_text">
            <div class="h1">
              <i>合计：</i><em>{{ items.totalPrice }}</em>
            </div>
          </div>
          <div class="place_btn on" v-if="Object.keys(address).length === 0">
            提交订单
          </div>
          <div class="place_btn" @click="payHandle()" v-else>提交订单</div>
        </div>
      </div>
    </div>
  </div>
  <ConsigneeInformation
    :isShow="showSetAddress"
    @closeAddress="closeAddress"
    @saveAddress="saveAddress"
    @canClose="canClose"
  />
</template>
<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { posts } from '../utils/posts'
import { useStore } from 'vuex'
import crumb from '../components/bread-crumb/Index.vue'
import ConsigneeInformation from '../components/ConsigneeInformation.vue'
export default {
  name: '产品中心',
  components: {
    crumb,
    ConsigneeInformation
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const addressList = ref([]) // 地址列表
    const address = ref({}) // 选中地址对象
    const chooseAddIndex = ref(-1) // 选中地址索引
    const showSetAddress = ref(false)
    const userInfo = store.state.userInfo || { uid: 0 }
    const opid = route.query.id
    const items = ref({}) // 商品详情
    const couponList = ref([]) // 获取优惠卷列表
    const couponId = ref(0) // 选中的优惠
    const payType = ref(1) // 支付类型 1：微信支付 4：支付宝支付
    const balanceDeduction = ref(false)

    // 提交订单
    const payHandle = () => {
      const payObj = {
        opid: opid,
        couponId: couponId.value,
        userName: address.value.consignee,
        mobile: address.value.telePhone,
        province: address.value.province,
        city: address.value.city,
        district: address.value.district,
        addressDetail: address.value.detailAddress,
        remarks: '',
        balanceDeduction: balanceDeduction.value ? 1 : 0,
        retailId: 0,
        source: 4,
        payType: payType.value
      }
      posts(`order/sumbit/${userInfo.uid}`, payObj).then((res) => {
        if (res.data.isPay) {
          location.href = res.data.navUrl
        } else {
          router.push({ path: '/mine/order' })
        }
      })
    }
    //
    const selectPayType = (val) => {
      payType.value = val
    }
    // 增加收货地址
    const setAddress = () => {
      document.body.style.overflow = 'hidden'
      showSetAddress.value = true
    }
    // 余额抵扣
    const leaveHandle = () => {
      balanceDeduction.value = !balanceDeduction.value
      confirmHandle()
    }
    // 获取优惠卷列表
    const couponHandle = () => {
      posts(`coupon/getcoupon/${userInfo.uid}`, { opid }).then((res) => {
        couponList.value = res.data
      })
    }
    // 选择优惠卷
    const selectConp = (item, index) => {
      if (item.status === 0) return

      const newcouponId = item.id
      if (newcouponId === couponId.value) {
        couponId.value = 0
      } else {
        couponId.value = newcouponId
      }
      confirmHandle()
    }
    // 保存收货地址
    const saveAddress = (obj) => {
      posts(`address/update/${userInfo.uid}`, obj).then((res) => {
        showSetAddress.value = false
        document.body.style.overflow = ''
        getAddressList()
      })
    }
    // 选择地址
    const selectAddress = (index) => {
      chooseAddIndex.value = index
      address.value = addressList.value[index]
    }
    // 关闭地址
    const closeAddress = () => {
      document.body.style.overflow = ''
      showSetAddress.value = false
    }
    // 关闭弹出层
    const canClose = () => {
      showSetAddress.value = false
    }
    // 获取地址列表
    const getAddressList = () => {
      posts(`address/get/${userInfo.uid}`, {}).then((res) => {
        addressList.value = res.data
      })
    }
    // 获取订单详情
    const confirmHandle = () => {
      posts('order/confirm/' + userInfo.uid, {
        opid,
        couponId: couponId.value,
        balanceDeduction: balanceDeduction.value ? 1 : 0
      })
        .then((res) => {
          items.value = res.data
        }).catch(e => {
          router.push({ path: '/mine/order' })
        })
    }
    onMounted(() => {
      confirmHandle()
      getAddressList()
      couponHandle()
    })
    return {
      selectPayType,
      payHandle,
      leaveHandle,
      payType,
      couponId,
      selectConp,
      couponHandle,
      couponList,
      selectAddress,
      saveAddress,
      getAddressList,
      canClose,
      setAddress,
      closeAddress,
      showSetAddress,
      chooseAddIndex,
      address,
      addressList,
      balanceDeduction,
      items,
      confirmHandle
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
}
.lg {
  display: flex;
  flex-direction: column;
  margin: 36px 0 0 0;
}
.balac {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.place_box {
  width: 100%;
  padding: 20px 20px 36px 20px;
  margin: 0 0 24px 0;
  background: white;
  &.total {
    background: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 0 36px 20px;
  }
  &.info {
    padding: 20px 100px 20px 20px;
  }
  .plac_leave {
    padding: 0 10px 0 0;
    display: flex;

    .leave_item {
      padding: 0 4px;
      em {
        font-size: 14px;
        font-weight: 600;
        color: #fc4353;
      }
      i {
        font: 14px;
      }
    }
  }
  .place_text {
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    color: #3e3a39;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 16px 0 0;
    i {
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      color: #3e3a39;
    }
    em {
      font-size: 24px;
      font-weight: bold;
      line-height: 28px;
      color: #fc4353;
      &:before {
        content: "￥";
      }
    }
  }
  .place_btn {
    width: 164px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
    opacity: 1;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    &.on {
      background: #999999;
    }
  }
  .place_roll {
    display: flex;
    flex-wrap: wrap;
    .roll_item {
      width: 364px;
      height: 136px;
      background: url(../assets/images/roll3.png) no-repeat center;
      background-size: contain;
      padding: 16px 26px 0 16px;
      display: flex;
      align-items: center;
      margin: 0 20px 20px 0;
      &.on {
        background: url(../assets/images/roll4.png) no-repeat center;
        .roll_con {
          .roll_sum {
            i {
              background: #9999;
              span {
                color: #9999;
              }
            }
            em {
              color: #9999;
            }
          }
        }
      }

      .roll_con {
        width: 269px;
        display: flex;
        flex-direction: column;
        margin: 0 32px 0 0;

        .roll_time {
          font-size: 12px;
          font-weight: 400;
          line-height: 28px;
          color: #999999;
        }
        .roll_title {
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #3e3a39;
        }
        .roll_sum {
          display: flex;
          align-items: center;
          margin: 0 0 10px 0;
          em {
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: 600;
            line-height: 28px;
            color: #fc4353;
            margin: 0 8px 0 0;
          }
          i {
            background: #fc435228;
            border-radius: 2px;
            padding: 4px 9px;
            display: flex;
            align-items: center;
            span {
              color: #fc4353;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .tbody {
    display: flex;
    margin: 0 0 24px 0;
    .td1 {
      flex: 4;
      display: flex;
      .td_img {
        width: 80px;
        height: 80px;
        overflow: hidden;
        margin: 0 12px 0 0;
      }
      .td_con {
        padding: 0 20px 0 0;
        width: 400px;
        .td_title {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: #3e3a39;
          margin: 0 0 12px 0;
        }
        .td_text_con {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .td_ge {
          display: flex;
          flex-direction: row;
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #999999;
        }
      }
    }
    .td2 {
      flex: 1.5;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .td3 {
      flex: 1.5;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .td4 {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .thead {
    display: flex;
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #3e3a39;
    .th1 {
      flex: 4;
    }
    .th2 {
      flex: 1.5;
      text-align: center;
    }
    .th3 {
      flex: 1.5;
      text-align: center;
    }
    .th4 {
      flex: 1;
      text-align: center;
    }
  }
  .address {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 352px;
      height: 104px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      padding: 16px;
      margin: 10px 20px 10px 0;
      cursor: pointer;
      &.add {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .address_add {
        background: #ffffff;
        font-weight: 400;
        font-size: 14px;
        position: relative;
        cursor: pointer;
        &:before {
          content: "";
          display: inline-block;
          background: url(../assets/images/add.png) no-repeat center;
          width: 13px;
          height: 13px;
          margin: 0 2px 0 0;
          position: absolute;
          top: 2px;
          left: -18px;
        }
      }
      &.on {
        border: 1px solid #fc4353;
      }
      .add_text {
        color: #999999;
      }
      .add_item {
        display: flex;
        justify-content: space-between;
        margin: 0 0 16px 0;
      }
    }
  }
  .place_title {
    width: 100%;
    font-size: 18px;
    font-weight: 400;
    color: #3e3a39;
    margin: 0 0 16px 0;
  }
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #fc4353;
  border: 1px solid #fc4353;
}
.select_item {
  width: 20px;
  height: 20px;
  border: 1px solid #999999;
  position: relative;
  cursor: pointer;
}
.select_item_on {
  border: 0 !important;
  background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
}
.select_item_on::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 4px;
  margin: auto;
  width: 7px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.paytype {
  display: flex;
}
.paytype .item {
  padding: 8px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
}
.paytype .item:not(:first-child) {
  margin-left: 20px;
}
.paytype .paytypeon,
.address .item .choose {
  color: #000000;
  border: 1px solid #ff0303;
  position: relative;
}
.paytype .paytypeon::before,
.address .item .choose::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-bottom: 20px solid #ff0303;
  border-left: 20px solid transparent;
  bottom: 0;
  right: 0;
}
.paytype .paytypeon::after,
.address .item .choose::after {
  position: absolute;
  content: "";
  bottom: 2px;
  right: 3px;
  margin: auto;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.paytype .item:hover {
  color: black;
  border: 1px solid #ff0303;
}
</style>
